var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusStop1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bus_stop",
    "data-name": "bus stop",
    transform: "translate(-252 -218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_846",
    "data-name": "Ellipse 846",
    transform: "translate(252 218)",
    fill: "#19bc9c",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bus_stop-2",
    "data-name": "bus stop",
    transform: "translate(255 221)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3844",
    "data-name": "Rectangle 3844",
    width: 18,
    height: 18,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15705",
    "data-name": "Group 15705",
    transform: "translate(1.8 3.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3846",
    "data-name": "Rectangle 3846",
    d: "M1.252.626a.627.627,0,0,0-.626.626v7.1a.627.627,0,0,0,.626.626H7.1a.627.627,0,0,0,.626-.626v-7.1A.627.627,0,0,0,7.1.626H1.252m0-.626H7.1A1.252,1.252,0,0,1,8.348,1.252v7.1A1.252,1.252,0,0,1,7.1,9.6H1.252A1.252,1.252,0,0,1,0,8.348v-7.1A1.252,1.252,0,0,1,1.252,0Z",
    transform: "translate(4.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_14",
    "data-name": "Subtraction 14",
    d: "M1758.878-2512.287v-2.087h-1.252v2.087h1.252m.626.626H1757v-2.922a.418.418,0,0,1,.417-.417h1.67a.418.418,0,0,1,.417.417Z",
    transform: "translate(-1755.852 2522.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3847",
    "data-name": "Rectangle 3847",
    d: "M.626.626V4.8h7.1V.626H.626M0,0H8.348V5.426H0Z",
    transform: "translate(4.904 1.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_719",
    "data-name": "Line 719",
    d: "M-.124,4.591H-.75V0h.626Z",
    transform: "translate(9.724 1.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_717",
    "data-name": "Line 717",
    d: "M2.067-.124h-2.5A.313.313,0,0,1-.75-.437.313.313,0,0,1-.437-.75h2.5a.313.313,0,0,1,.313.313A.313.313,0,0,1,2.067-.124Z",
    transform: "translate(8.263 8.367)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_714",
    "data-name": "Line 714",
    d: "M-.437,1.128A.313.313,0,0,1-.75.815V-.437A.313.313,0,0,1-.437-.75a.313.313,0,0,1,.313.313V.815A.313.313,0,0,1-.437,1.128Z",
    transform: "translate(2.837 6.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_715",
    "data-name": "Line 715",
    d: "M-.124,1.252H-.75V0h.626Z",
    transform: "translate(6.593 9.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_720",
    "data-name": "Line 720",
    d: "M-.124,1.252H-.75V0h.626Z",
    transform: "translate(10.767 9.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_718",
    "data-name": "Line 718",
    d: "M-.124,1.252H-.75V0h.626Z",
    transform: "translate(8.263 9.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_721",
    "data-name": "Line 721",
    d: "M-.124,1.252H-.75V0h.626Z",
    transform: "translate(12.437 9.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_716",
    "data-name": "Line 716",
    d: "M13.337-.124H-.437A.313.313,0,0,1-.75-.437.313.313,0,0,1-.437-.75H13.337a.313.313,0,0,1,.313.313A.313.313,0,0,1,13.337-.124Z",
    transform: "translate(0.75 10.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_853",
    "data-name": "Ellipse 853",
    cx: 0.417,
    cy: 0.417,
    r: 0.417,
    transform: "translate(6.365 7.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_853_-_Outline",
    "data-name": "Ellipse 853 - Outline",
    d: "M.417,0A.417.417,0,1,1,0,.417.417.417,0,0,1,.417,0Z",
    transform: "translate(6.365 7.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_854",
    "data-name": "Ellipse 854",
    cx: 0.417,
    cy: 0.417,
    r: 0.417,
    transform: "translate(10.957 7.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_854_-_Outline",
    "data-name": "Ellipse 854 - Outline",
    d: "M.417,0A.417.417,0,1,1,0,.417.417.417,0,0,1,.417,0Z",
    transform: "translate(10.957 7.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_852",
    "data-name": "Ellipse 852",
    d: "M1.67.626A1.043,1.043,0,1,0,2.713,1.67,1.045,1.045,0,0,0,1.67.626M1.67,0A1.67,1.67,0,1,1,0,1.67,1.67,1.67,0,0,1,1.67,0Z",
    transform: "translate(0.73 2.504)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusStop1);
export default __webpack_public_path__ + "static/media/bus-stop-1.3e2947efdd57d800ef6d2d2760a99aca.svg";
export { ForwardRef as ReactComponent };